// extracted by mini-css-extract-plugin
module.exports = {"root":"OperationType_root__3l62n","query":"OperationType_query__1hVBt","mutation":"OperationType_mutation__15f0k"};